/* eslint-disable @typescript-eslint/no-unsafe-function-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {useFocusEffect, useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import React, {useState} from 'react';
import {Linking, Platform, View} from 'react-native';
import {connect} from 'react-redux';

import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import {getNextDay, handleDateValue} from '../../../../common/utils/date';
import {getTypeContratPayment} from '../../../../common/utils/paiement';
import {Validation} from '../../../../common/utils/paiement/validationOrange';
import {separateurMillier} from '../../../../common/utils/rendering';
import config from '../../../../data/config';
import {initModalData} from '../../../../data/constants/Assurance/AssuranceVoyage/souscription';
import {
  defaultOrangeMoneyErrorValues,
  ERROR_MESSAGE,
  LOADING_MESSAGE,
  redirectRoutesAfterPayment,
  showErrorValuesDefault,
  showErrorValuesSubmit,
  SUCCESS_MESSAGE,
  TRANSACTION_ERROR_MSG,
} from '../../../../data/constants/paiement';
import {
  formatDataForRapatriementRenewal,
  sendInfo,
} from '../../../../data/factory/paiement';
import {
  IOrangeMoney,
  IOrangeMoneyError,
} from '../../../../data/types/interface/paiement';
import {StackParams} from '../../../../data/types/navigation';
import mapDispatchToProps from '../../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../../services/redux/mapStateToProps';
import SubmitButtons from '../../../components/Button/SecondaryButton';
import {HeaderScreen} from '../../../components/Header/HeaderScreen';
import {InputDatePicker} from '../../../components/Inputs/InputDatePicker';
import {InputField} from '../../../components/Inputs/InputField';
import Label from '../../../components/Label';
import LoaderWithMessage from '../../../components/LoaderWithMessage';
import ConfirmationModal from '../../../components/Modal/ConfirmationModal';
import {PageContainer} from '../../../components/PageContainer';

type NavigationProps = StackNavigationProp<StackParams, 'OrangePayment'>;

export const OrangePaymentForm = (props: any) => {
  const {
    orangemoneyUser,
    orangemoneyTransactionUser,
    checkOrangeTransactionUser,
    user,
  } = props;

  const {contratEC = {}} = props?.user || {};

  const {navigate, goBack} = useNavigation<NavigationProps>();
  const primTTC = contratEC.primeTTC || contratEC.montant || 0;
  const premierVersement = contratEC.premierVersement
    ? contratEC.premierVersement
    : 0;
  const [transactionId, setTransactionId] = useState<string>('');

  const nextDay: Date = React.useMemo(() => {
    return (
      dayjs(contratEC.dateEffet).toDate() ||
      dayjs(contratEC.dateDebut).toDate() ||
      getNextDay(new Date(handleDateValue(contratEC.dateEcheance)))
    );
  }, [contratEC]);

  const [values, setValues] = React.useState<IOrangeMoney>({
    montant:
      contratEC.typeContrat === undefined &&
      contratEC.typePayment !== 'prime' &&
      contratEC.typePayment !== 'renouvellement'
        ? 0
        : contratEC.typeContrat === 'retraite'
        ? premierVersement
        : primTTC,
    motif: '',
    typeContrat: contratEC.typeContrat,
    simulationId: contratEC.simulationId,
    numeroPolice: contratEC.numeroPolice,
    dateEffet: nextDay.toString() || '',
  });
  const [error, setError] = React.useState<IOrangeMoneyError>(
    defaultOrangeMoneyErrorValues,
  );
  const [showErrors, setShowErrors] = useState(showErrorValuesDefault);
  const [IsLoading, setIsLoading] = useState(false);
  const [loaderMessage, setLoaderMessage] = useState(' ');
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [infoMessage, setInfoMessage] = useState('');
  interface ModalDataDTO {
    status: boolean;
    title: string;
    content: string | React.ReactNode;
    btn1: string;
    btn2?: string | undefined;
    handleBtn1: Function;
    handleBtn2?: Function | undefined;
  }

  const [modalData, setModalData] = useState<ModalDataDTO>({...initModalData});

  const showInfoMessage = (message: string) => {
    checkOrangeTransactionUser('Succes', () => {});
    setInfoMessage(message);
    setShowInfoModal(true);
  };

  const showErrorMessage = (message: string) => {
    setErrorMessage(message);
    setShowErrorModal(true);
  };

  const infoOkCompletion = () => {
    setShowInfoModal(false);
    sendInfo({
      ...props,
      user: {
        ...props.user,
        contratEC: {
          ...props.user.contratEC,
          dateEffet: values.dateEffet,
          transactionId,
        },
      },
      okCompletion: redirectToHome,
      showError: showErrorMessage,
      setIsLoading: () => {
        setIsLoading(false);
      },
    });
  };

  const handleCancel = () => {
    goBack();
  };

  const goToWebView = (url: string) => {
    setTimeout(() => {
      setLoaderMessage(LOADING_MESSAGE);
    }, 1000);
    setShowInfoModal(false);
    if (Platform.OS !== 'web') {
      navigate('PaymentWebView', {
        url: url,
        titleHeader: 'Orange money',
      });
    } else {
      Linking.openURL(url)
        .then(() => {
          console.log('opened success');
        })
        .catch((error: any) => {
          console.log('error Linking.opeURL', error);

          setModalData({
            status: true,
            title: 'Information',
            content:
              "Veuillez autoriser l'application a ouvrir la plateforme orange money",
            btn1: 'OK',
            handleBtn1: () => setModalData({...initModalData}),
          });
        });
    }
  };

  const sendPayment = () => {
    setIsLoading(true);
    const contrat = user && user.contratEC && user.contratEC.typeContrat;

    if (
      contrat === 'retraite' ||
      (contratEC.typeContratPayment === 'retraite' &&
        (contratEC.primeTTC === '' || contratEC.typeContrat === undefined))
    ) {
      values.typeContrat = 'retraite';
      values.simulationId = contratEC.simulationId;
    } else {
      values.typeContrat = getTypeContratPayment(
        contrat,
        contratEC?.typeContratPayment,
      );
    }

    values.montant = +values.montant.toString().replace(/[^0-9]/g, '');

    const extraInformation =
      values.typeContrat == 'rapatriement'
        ? formatDataForRapatriementRenewal(contratEC)
        : {};

    orangemoneyUser(
      {
        ...values,
        typePayment: contratEC.typePayment ?? '',
        dateEffet: values.dateEffet
          ? dayjs(values.dateEffet).isValid()
            ? dayjs(values.dateEffet).format('DD/MM/YYYY')
            : values.dateEffet
          : dayjs().format('DD/MM/YYYY'),
        numeroPolice: props.user.numeroPolice,
        ...extraInformation,
      },
      (res: any) => {
        if (res && res.data) {
          if (res?.data?.transactionId) {
            goToWebView(res.data.paiementUrl);
            setTimeout(() => {
              orangemoneyTransactionUser(
                {},
                (statusRes: any) => {
                  if (statusRes?.orangeTransactionResponse?.data !== 'Succès') {
                    showErrorMessage(TRANSACTION_ERROR_MSG);
                  } else {
                    setTransactionId(() => res.data.transactionId);
                    showInfoMessage(SUCCESS_MESSAGE);
                  }
                  setIsLoading(false);
                },
                `/${res.data.transactionId}`,
              );
            }, 90 * 1000);
          } else {
            console.log('ato');

            showErrorMessage(ERROR_MESSAGE);
            setShowInfoModal(() => false);
            setIsLoading(() => false);
          }
        } else {
          setIsLoading(() => false);
        }
      },
    );
  };

  const handleSubmit = () => {
    setShowErrors(showErrorValuesSubmit);
    setError(Validation(contratEC, values));
    if (noError(Validation(contratEC, values))) {
      setModalData({
        status: true,
        title:
          'Obtenir votre code paiement depuis votre mobile avant de lancer le paiement.',
        content: (
          <View style={Platform.OS === 'ios' ? {} : {flex: 1}}>
            <Label title={'1) Appelez #144#.'} />
            <Label title={'2) Choisissez 3: Paiements & Partenaires'} />
            <Label title={'3) Choisissez 3: Paiement en ligne'} />
            <Label title={'4) Entrez votre code secret pour obtenir le'} />
            <Label title={' code paiement'} />
            <Label title={'5) Le code obtenu va être renseigné dans '} />
            <Label title={' le champ "Code de paiement" de la page '} />
            <Label title={' Orange Money qui va suivre'} />
            <Label
              style={{marginTop: 30}}
              title={'(Code paiement reçu, lancer le paiement)'}
              type="fourthTitle"
            />
          </View>
        ),
        btn1: 'Lancer le paiement',
        btn2: 'Annuler',
        handleBtn1: () => {
          setModalData({...initModalData});
          sendPayment();
        },
        handleBtn2: () => setModalData({...initModalData}),
      });
    }
  };

  const redirectToHome = (paramsSend: any) => {
    setIsLoading(false);
    const route = redirectRoutesAfterPayment[paramsSend.title];

    if (route) {
      navigate(route, {id: paramsSend.id});
    } else if (paramsSend.numeroPolice) {
      navigate('DetailContrat', paramsSend);
    } else {
      navigate('Home');
    }
  };

  const noError = (validation: any) => {
    let bNoError = true;
    Object.values(validation).forEach(element => {
      if (element !== '') {
        bNoError = false;
      }
    });
    return bNoError;
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleChange = (name: string, value: any, fired: boolean) => {
    setShowErrors(prevShowErrors => ({
      ...prevShowErrors,
      montant: false,
      motif: false,
    }));
    setValues((prevValues: IOrangeMoney) => ({...prevValues, [name]: value}));
    setError(Validation(contratEC, {...values, [name]: value}));
  };

  const backToMonEspace = () => {
    setShowErrorModal(false);
    navigate('MonEspace');
  };

  useFocusEffect(
    React.useCallback(() => {
      setValues({
        montant:
          contratEC.typeContrat === undefined &&
          contratEC.typePayment !== 'prime' &&
          contratEC.typePayment !== 'renouvellement'
            ? 0
            : contratEC.typeContrat === 'retraite'
            ? premierVersement
            : primTTC,
        motif: '',
        typeContrat: contratEC.typeContrat,
        simulationId: contratEC.simulationId,
        numeroPolice: contratEC.numeroPolice,
        dateEffet:
          contratEC.typePayment === 'souscription'
            ? contratEC.dateEffet
            : nextDay.toISOString() || '',
      });
    }, [contratEC]),
  );

  return (
    <View>
      <HeaderScreen title="Orange Money" type="retour" noBreadcrumb={false} />
      <PageContainer>
        <LoaderWithMessage
          message={loaderMessage}
          isModal={Platform.OS === 'web'}
          isLoading={IsLoading}
        />
        {!IsLoading && (
          <View>
            <View>
              <InputField
                label={
                  contratEC.typeContrat === undefined &&
                  contratEC.typePayment === 'cotisation'
                    ? 'Montant (minimum : 2000 Ar)'
                    : 'Montant (Ar)'
                }
                required
                value={
                  values.montant === 0 ? '' : separateurMillier(values.montant)
                }
                name="montant"
                type="price"
                onChange={handleChange}
                error={error.montant}
                showError={showErrors.montant}
                isEditable={
                  contratEC.typePayment === 'cotisation' ||
                  contratEC.typeContrat === 'retraite' ||
                  !!config.montantEditable
                }
                // isEditable
              />
              {contratEC.typeContrat != 'rcvp' &&
              contratEC.typeContrat != 'scolaire' &&
              contratEC.typeContrat != 'rattache' &&
              (contratEC.typePayment === 'prime' ||
                contratEC.typePayment === 'renouvellement') ? (
                <InputDatePicker
                  label={"Date d'effet"}
                  required
                  value={values.dateEffet}
                  name="dateEffet"
                  onChange={handleChange}
                  dateMin={getNextDay(
                    new Date(handleDateValue(contratEC.dateEcheance)),
                  )}
                  isEditable={!(contratEC.typePayment != 'rapatriement')}
                />
              ) : null}
              <InputField
                label="Motif"
                required
                value={values.motif}
                name="motif"
                onChange={handleChange}
                error={error.motif}
                showError={showErrors.motif}
                maxLength={20}
              />
            </View>
            <View>
              <SubmitButtons
                cancelAction={handleCancel}
                submitAction={handleSubmit}
                cancelTitle="Annuler"
                submitTitle="Valider"
              />
            </View>
          </View>
        )}

        {modalData.status && (
          <ConfirmationModal
            contentStyle={{textAlign: 'left'}}
            title={modalData.title}
            content={modalData.content}
            btn1={modalData.btn1}
            btn2={modalData.btn2}
            handleBtn1={modalData.handleBtn1}
            handleBtn2={modalData.handleBtn2}
          />
        )}

        {/** Error modal */}
        {showErrorModal && (
          <ConfirmationModal
            title="Erreur"
            content={errorMessage}
            btn1="OK"
            handleBtn1={backToMonEspace}
          />
        )}

        {/** Confirmation  modal */}
        {showInfoModal && (
          <ConfirmationModal
            title="Information"
            content={infoMessage}
            btn1="OK"
            handleBtn1={infoOkCompletion}
          />
        )}
      </PageContainer>
    </View>
  );
};

export const OrangePayment: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(OrangePaymentForm);
